import React, { useEffect, useState } from "react";

export default function ToggleSwitch({
  checked = false,
  onChange,
  label,
  onLabel = null,
  offLabel = null,
  name,
  disabled=false,
}) {
  const [id] = useState(Math.random().toString(36).substring(2));
  return (
    <div className="flex items-center">
      <div className="form-switch">
        {onChange ? (
          <input
            type="checkbox"
            id={id}
            className="sr-only"
            checked={checked}
            onChange={() => {
              onChange(!checked);
            }}
            disabled={disabled}
            name={name}
          />
        ) : (
          <input
            disabled={disabled}
            type="checkbox"
            id={id}
            className="sr-only"
            defaultChecked={checked}
            name={name}
          />
        )}
        <label className="bg-theme-accent" htmlFor={id}>
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
          <span className="sr-only">{label}</span>
        </label>
      </div>
      {onLabel || offLabel ? (
        <div className={"ml-2 "+(disabled?'text-slate-400':'')}>{checked ? onLabel : offLabel}</div>
      ) : null}
    </div>
  );
}
